import { Grid } from '@mui/material';

// Our Components
import BalanceAndMonthyAmountCard from 'components/SoraWallet/Cards/BalanceAndMonthyAmountCard';
import DetailedListCard from 'components/SoraWallet/Cards/DetailedListCard';
import InterestAndYearsRemainingCard from 'components/SoraWallet/Cards/InterestAndYearsRemainingCard';
import LoanTypeAndCostOfDebtCard from 'components/SoraWallet/Cards/LoanTypeAndCostOfDebtCard';
import SoraInsightsMortgageCarousel from 'components/Carousel/SoraInsightsMortgageCarousel';

const DEFAULT_ROW_SPACING = 6;

function HomeWallet({
	currentLoanDetails,
	firstName,
	formattedSoraGrade,
	isClient,
	lastName,
	walletLiabilityData
}) {
	const { currentLoan } = walletLiabilityData;

	const { home: homeDetails, lender } = currentLoanDetails;

	return (
		<Grid
			container
			item
			xs={12}
			columnSpacing={3}
			rowSpacing={DEFAULT_ROW_SPACING}
			sx={{
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-evenly'
			}}
		>
			<Grid item xs={12} md={4} xl={4}>
				<LoanTypeAndCostOfDebtCard
					currentLoanDetails={currentLoanDetails}
					homeDetails={homeDetails}
					lender={lender}
				/>
			</Grid>
			<Grid item xs={12} md={4} xl={4}>
				<BalanceAndMonthyAmountCard
					currentLoanDetails={currentLoanDetails}
				/>
			</Grid>
			<Grid item xs={12} md={4} xl={4}>
				<InterestAndYearsRemainingCard
					remainingMonth={currentLoanDetails?.remainingMonth}
					currentLoanDetails={currentLoanDetails}
				/>
			</Grid>

			<SoraInsightsMortgageCarousel isClient={isClient} />

			<Grid item sm={12}>
				<DetailedListCard
					variant="property"
					cardHeading="Property Data"
					currentLoan={currentLoan}
				/>
			</Grid>

			<Grid item sm={12} sx={{ marginBottom: 5 }}>
				<DetailedListCard
					variant="liability"
					cardHeading="Current Liabilities Data"
					currentLoan={currentLoan}
				/>
			</Grid>
		</Grid>
	);
}

export default HomeWallet;
